import { LocationDescriptorObject } from 'history';
import React from 'react';
import { useSelector } from 'react-redux';
import { Redirect, Route, RouteProps, useLocation } from 'react-router-dom';
import routes from '../routes';
import { getIsAuthenticated } from '../store/modules/auth/reducer';

const AuthRoute = (props: RouteProps) => {
  const isAuthenticated = useSelector(getIsAuthenticated);
  const location = useLocation<{ referrer?: LocationDescriptorObject }>();
  const to = location.state?.referrer ?? routes.Home;
  to.search = location.search;
  if (isAuthenticated) {
    return <Redirect to={to} />;
  }
  return <Route {...props} />;
};

export default AuthRoute;
